<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div class="bg-white rounded-xl shadow-lg max-w-sm w-full p-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Change Role for {{ user?.first_name }} {{ user?.last_name }}
        </h3>

        <BaseSelect
          v-model="internalSelectedRole"
          :options="roles.map(r => ({ value: r.id.toString(), label: r.name }))"
          placeholder="-- Select Role --"
          :showPlaceholder="true"
        />

        <div class="flex justify-between mt-6">
          <BaseButton variant="cancel" @click="close">Cancel</BaseButton>
          <BaseButton @click="save">Save</BaseButton>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseSelect from "@/BaseComponents/BaseSelect.vue";
import BaseButton from "@/BaseComponents/BaseButton.vue";

export default {
  components: { BaseSelect, BaseButton },
  props: {
    isOpen: Boolean,
    user: Object,
    roles: Array,
    selectedRole: String
  },
  emits: ["update:isOpen", "update:selectedRole", "save"],
  data() {
    return {
      internalSelectedRole: this.selectedRole || ""
    };
  },
  watch: {
    selectedRole(newVal) {
      this.internalSelectedRole = newVal;
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    save() {
      this.$emit("update:selectedRole", this.internalSelectedRole);
      this.$emit("save");
      this.close();
    }
  }
};
</script>
